import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const preventLineBreaks = e => {
  if (e.key === 'Enter') e.preventDefault();
};

const CustomMessage = ({ message, onChange }) => (
  <div className="mt-48">
    <h2 className="ff-ss">
      {t('in_person_training.invite_users.add_custom_message')}
    </h2>
    <span>
      <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
        {t('common.optional')}
      </Text>
    </span>

    <textarea
      onKeyDown={preventLineBreaks}
      className="AssignModal-messageInput mt-8"
      onChange={e => onChange(e.target.value)}
      value={message}
    />
  </div>
);

export default CustomMessage;
